<template>
  <div class="base-footer">
    <div class="base-footer-content">
      <div class="line-one">
        <img src="../../deps/public/solplanet-logo-white.png" alt="" @click="$router.push({ name: 'OnlineClaim' })">
        <div class="links">
          <a href="https://solplanet.net/privacy/" target="_blank"><span class="bbm">privacy</span></a>
          <a href="https://solplanet.net/imprint/" target="_blank"><span>Imprint</span></a>
          <a href="https://solplanet.net/iso-9001/" target="_blank"><span>ISO 9001</span></a>
          <a href="https://solplanet.net/iso-14001/" target="_blank"><span>ISO 14001</span></a>
          <a href="https://solplanet.net/#gdpr-modal" target="_blank"><span>Cookies</span></a>
        </div>
        <div class="img-links">
            <a href="https://www.linkedin.com/company/solplanet" target="_blank"><img src="../../deps/public/footer1.png" alt=""></a>
            <a href="https://www.facebook.com/Solplanet-108274294049434" target="_blank"><img src="../../deps/public/footer2.png" alt=""></a>
            <a href="https://www.youtube.com/channel/UCa5ZJFftpNvlyjTEHiiGu1g" target="_blank"><img src="../../deps/public/footer3.png" alt=""></a>
            <a href="https://www.instagram.com/solplanet_tech/?hl=en" target="_blank"><img src="../../deps/public/footer4.png" alt=""></a>
            <a href="https://twitter.com/aisweitech?lang=en" target="_blank"><img src="../../deps/public/footer5.png" alt=""></a>
        </div>
      </div>
      <div class="line-two">
          <span><p>Copyright © 2020 AISWEI New Energy Technology (Jiangsu) Co., Ltd.</p></span>
          <span><img src="../../deps/public/footer6.png" alt=""></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="stylus">
.base-footer {
  background: #fff;
  border-top: 1px solid #dadada;
  background: #3e3e3e;
  height: 221px;

  .base-footer-content{
    width:60%;
    margin: 0 auto;
    height:100%;
    padding:30px 0;
    .line-one{
      display: flex;
      height: 30px;
      line-height: 30px;
      justify-content: space-between;
      >img{
        margin-right:10px;
      }
      .links{
        span{
          cursor:pointer;
          font-size: 10px;
          display:inline-block;
          height:100%;
          font-weight: 600;
          line-height:35px;
          color: #D5D5D5;
          margin-right: 10px;
          &:hover{
            border-bottom:1px solid #D8D8D8;
          }
        }
      }
      .img-links{
        img{
          cursor:pointer;
          margin-right: 10px;
        }
      }
    }
    .line-two{
      margin-top:90px;
      display:flex;
      justify-content: space-between;
      height:42px;
      // line-height:42px;
      >span{
        display:inline;  
        font-size: 11px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #838383;
        p{
          width:250px;
        }
      }
    }
  }
}

.isPhone .base-footer {
  height: auto;
  .base-footer-content{
    width:80%;
  }
  .line-one{
    height:auto;
     flex-direction:column
     >img{
       width:100px;
     }
     .links span{
       height:auto;
       line-height:unset;
     }
  }
  .line-two{
    height:auto;
    margin-top:5px;
    flex-direction:column;
    >span{
      img{
        width:350px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/modules/baseFooter/index.vue